<template>
  <v-row>
    <v-col>
      <v-menu
        ref="datepicker"
        :close-on-content-click="false"
        v-model="datepicker"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :rules="[validDate]"
            v-model="date"
            :label="dateHeader"
            :disabled="disabled"
            type="date"
            outlined
            v-bind="attrs"
            v-on="on"
            hint="Obligatorisk"
          />
        </template>
        <v-date-picker
          locale="sv"
          first-day-of-week="1"
          v-model="date"
          @change="updateValue"
          no-title
          @input="datepicker = false"
        />
      </v-menu>
    </v-col>
    <v-col v-if="!dateOnly" cols="4">
      <v-text-field
        :rules="[validTime]"
        v-model="time"
        :disabled="disabled"
        type="time"
        :label="timeHeader"
        outlined
        hint="Obligatorisk"
        @change="updateValue"
      />
    </v-col>
  </v-row>
</template>

<script>
import { format } from 'date-fns'
import { validDate, validTime } from '@/common/validationRules'

export default {
  name: 'ReportDateTime',

  props: {
    disabled: Boolean,
    value: String,
    dateOnly: {
      type: Boolean,
      default: false
    },
    dateHeader: {
      default: 'Datum',
      type: String
    },
    timeHeader: {
      default: 'Tid',
      type: String
    }
  },

  watch: {
    date: 'updateValue'
  },

  data: () => ({
    validDate,
    validTime,
    date: null,
    time: null,
    datepicker: false
  }),

  created() {
    const timeStart = new Date(this.value) || new Date()
    this.date = format(timeStart, 'yyyy-MM-dd')
    this.time = format(timeStart, 'HH:mm')

    this.updateValue()
  },

  methods: {
    updateValue() {
      if (this.dateOnly) {
        this.$emit('input', this.date)
      } else {
        this.$emit('input', `${this.date} ${this.time}`)
      }
    }
  }
}
</script>
